import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-541654d7"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "card-course" };
var _hoisted_2 = ["src"];
var _hoisted_3 = {
    key: 1,
    class: "w-full h-44 bg-primary bg-opacity-10 rounded-t-lg flex items-center justify-center"
};
var _hoisted_4 = {
    key: 2,
    class: "w-full h-1.5 bg-gray-100 absolute bottom-0 left-0"
};
var _hoisted_5 = {
    key: 3,
    class: "categories absolute flex flex-row-reverse items-center right-3 bottom-3 p-1.5 bg-black bg-opacity-30 rounded-full text-white"
};
var _hoisted_6 = { class: "flex flex-col flex-grow py-5 px-7 bg-white rounded-b-lg" };
var _hoisted_7 = { class: "flex-grow" };
var _hoisted_8 = {
    key: 0,
    class: "flex items-center font-medium text-primary"
};
var _hoisted_9 = { class: "ml-2.5" };
var _hoisted_10 = {
    key: 1,
    class: "flex items-center font-medium text-primary"
};
var _hoisted_11 = { class: "ml-2.5" };
var _hoisted_12 = {
    key: 2,
    class: "flex items-center font-medium text-primary"
};
var _hoisted_13 = { class: "ml-2.5" };
var _hoisted_14 = {
    key: 3,
    class: "flex items-center font-medium text-primary"
};
var _hoisted_15 = { class: "ml-2.5" };
var _hoisted_16 = {
    key: 4,
    class: "flex items-center font-medium text-primary"
};
var _hoisted_17 = { class: "ml-2.5" };
var _hoisted_18 = { class: "mt-4 text-gray-400" };
var _hoisted_19 = {
    key: 0,
    class: "mt-4"
};
var _hoisted_20 = {
    key: 1,
    class: "mt-4"
};
import EProgressPie from '@common/ui/EProgress/EProgressPie';
import { openLink } from '@common/utils/Helpers/Helpers';
import { CoreStore, CourseStore } from '@student/modules/store';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import ETooltip from '@common/ui/ETooltip.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CardCourse',
    props: {
        course: {},
        showAllCategories: { type: Boolean }
    },
    setup: function (__props) {
        var router = useRouter();
        var t = useI18n().t;
        var props = __props;
        var defaults = ref({ cover: '/img/content/courseBgSmall.jpg', });
        var schoolSubscriptionIsOverdue = computed(function () { return CoreStore.schoolSubscriptionIsOverdue; });
        var courseRouteName = computed(function () { return props.course.allowed ? 'courseLearn' : 'courseAbout'; });
        var isPlansPayment = computed(function () { return props.course.plansPayment; });
        var hasFreePlan = computed(function () {
            if (!isPlansPayment.value) {
                return false;
            }
            return props.course.plans.some(function (p) { return p.price === 0; });
        });
        var useLandingExternalUrl = computed(function () { return CourseStore.useLandingExternalUrl; });
        var landingExternalUrl = computed(function () { return CourseStore.landingExternalUrl; });
        var canEnterAbout = computed(function () { var _a, _b; return !!(props.course.useLandingExternalUrl || ((_b = (_a = props.course.landings) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.slug)); });
        var onCardClick = function () {
            if (schoolSubscriptionIsOverdue.value) {
                openSubscriptionModal();
            }
        };
        var openSubscriptionModal = function () {
            CoreStore.schoolSubscriptionModalVisible = true;
        };
        var onLinkClick = function (course) {
            var _a, _b;
            if (course.allowed) {
                router.push({
                    name: 'courseLearn', params: { courseId: course.id }
                }).catch(function () { });
                return;
            }
            if (course.useLandingExternalUrl) {
                openLink(course.landingExternalUrl);
                return;
            }
            if ((_b = (_a = course.landings) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.slug) {
                router.push({
                    name: 'courseAbout', params: { slug: course.landings[0].slug }
                }).catch(function () { });
            }
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ETooltip, {
                    disabled: !schoolSubscriptionIsOverdue.value,
                    "tooltip-text": _unref(t)('tooltip.accessBlocked'),
                    fullwidth: ""
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", {
                            class: "h-full",
                            onClick: onCardClick
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass([{ 'opacity-60 select-none pointer-events-none': schoolSubscriptionIsOverdue.value }, "flex flex-col shadow-custom rounded-lg h-full"])
                            }, [
                                _createElementVNode("div", {
                                    class: "block relative w-full cursor-pointer",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (onLinkClick(_ctx.course)); })
                                }, [
                                    (_ctx.course.cover)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _ctx.course.cover,
                                            class: "object-cover w-full h-44 rounded-t-lg"
                                        }, null, 8, _hoisted_2))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_component_e_icon, {
                                                class: "image-icon w-12 h-12",
                                                icon: "image-stack"
                                            })
                                        ])),
                                    (_ctx.course.allowed)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createElementVNode("div", {
                                                style: _normalizeStyle({
                                                    width: "".concat(_ctx.course.progressSuccess, "%"),
                                                }),
                                                class: "h-full bg-primary"
                                            }, null, 4)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.course.categories &&
                                        // Показываем только если категории есть
                                        _ctx.course.categories.length > 0 &&
                                        // Скрываем если только одна категория и нет флага
                                        (_ctx.showAllCategories || _ctx.course.categories.length > 1))
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.categories, function (category) {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: category.id,
                                                    class: _normalizeClass([{
                                                            'categories__item--open': _ctx.course.categories.length === 1,
                                                        }, "categories__item"])
                                                }, [
                                                    _createElementVNode("div", {
                                                        style: _normalizeStyle({
                                                            backgroundColor: category.color,
                                                        })
                                                    }, [
                                                        _createElementVNode("p", null, _toDisplayString(category.name), 1)
                                                    ], 4)
                                                ], 2));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        (_ctx.course.lessonsProgress >= _ctx.course.lessonsQuantity && _ctx.course.lessonsQuantity !== 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createVNode(_component_e_icon, {
                                                    class: "w-5 h-5",
                                                    icon: "course-completed"
                                                }),
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('course.completed')), 1)
                                            ]))
                                            : (_ctx.course.allowed && _ctx.course.lessonsProgress < _ctx.course.lessonsQuantity)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    _createVNode(_unref(EProgressPie), {
                                                        progress: _ctx.course.progressSuccess,
                                                        class: "w-5 h-5"
                                                    }, null, 8, ["progress"]),
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.course.progressSuccess) + "% " + _toDisplayString(_unref(t)('course.progress')), 1)
                                                ]))
                                                : (_ctx.course.price === 0 && !isPlansPayment.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                        _createVNode(_component_e_icon, {
                                                            class: "w-5 h-5",
                                                            icon: "course-free"
                                                        }),
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('course.free')), 1)
                                                    ]))
                                                    : (hasFreePlan.value && isPlansPayment.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                            _createVNode(_component_e_icon, {
                                                                class: "w-5 h-5",
                                                                icon: "course-free"
                                                            }),
                                                            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('course.freePlanAvailable')), 1)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                            _createVNode(_component_e_icon, {
                                                                class: "w-5 h-5",
                                                                icon: "course-price"
                                                            }),
                                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('course.availableForPurchase')), 1)
                                                        ])),
                                        _createElementVNode("a", {
                                            class: "block mt-3 text-lg font-medium cursor-pointer",
                                            onClick: _cache[1] || (_cache[1] = function ($event) { return (onLinkClick(_ctx.course)); })
                                        }, _toDisplayString(_ctx.course.name), 1),
                                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.course.shortDescription), 1)
                                    ]),
                                    (_ctx.course.allowed)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            (_ctx.course.lessonsProgress >= _ctx.course.lessonsQuantity && _ctx.course.lessonsQuantity !== 0)
                                                ? (_openBlock(), _createBlock(_component_e_button, {
                                                    key: 0,
                                                    "href-to": { name: courseRouteName.value, params: { courseId: _ctx.course.id } },
                                                    class: "w-full",
                                                    type: "primary-alt"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(_unref(t)('course.goToCourse')), 1)
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["href-to"]))
                                                : (_ctx.course.uncompletedLesson)
                                                    ? (_openBlock(), _createBlock(_component_e_button, {
                                                        key: 1,
                                                        "href-to": {
                                                            name: 'courseLesson',
                                                            params: {
                                                                courseId: _ctx.course.id,
                                                                stepId: _ctx.course.uncompletedLesson.step.id,
                                                                lessonId: _ctx.course.uncompletedLesson.lesson.id
                                                            }
                                                        },
                                                        class: "w-full",
                                                        type: "primary-alt"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(_component_e_icon, {
                                                                class: "mr-2.5 w-5 h-5",
                                                                icon: "course-continue"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(_unref(t)('course.continueLearning')), 1)
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["href-to"]))
                                                    : (_openBlock(), _createBlock(_component_e_button, {
                                                        key: 2,
                                                        "href-to": { name: courseRouteName.value, params: { courseId: _ctx.course.id } },
                                                        class: "w-full",
                                                        type: "primary-alt"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createTextVNode(_toDisplayString(_unref(t)('course.goToCourse')), 1)
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["href-to"]))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createVNode(ETooltip, {
                                                disabled: canEnterAbout.value,
                                                "tooltip-text": _unref(t)('tooltip.courseNotPublished'),
                                                trigger: "hover",
                                                fullwidth: ""
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(_component_e_button, {
                                                        disabled: !canEnterAbout.value,
                                                        class: "w-full",
                                                        type: "primary",
                                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (onLinkClick(_ctx.course)); })
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createTextVNode(_toDisplayString(_unref(t)('course.learnMore')), 1)
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["disabled"])
                                                ]; }),
                                                _: 1
                                            }, 8, ["disabled", "tooltip-text"])
                                        ]))
                                ])
                            ], 2)
                        ])
                    ]; }),
                    _: 1
                }, 8, ["disabled", "tooltip-text"])
            ]));
        };
    }
});
